<template>

<core-modal v-on:close="onClose" icon="caret-left">

	<template v-slot:head>

		Create View

	</template>

	<template v-slot:default>

		<core-form-input-textbox 
			:autofocus="true" 
			maxlength="16" 
			name="name" 
			v-on:validate="validate" 
			placeholder="Enter name" 
			v-model="model.name"
			:error="is.error" 
			:disabled="is.loading" 
			:validation="validation.name" 
		/>

		<core-form-input-togglelist 
			title="Type" 
			name="type" 
			v-on:validate="validate" 
			v-model="model.type" 
			:error="is.error" 
			:disabled="is.loading" 
			:validation="validation.type" 
			:options="typeOptions" 
		/>

		<core-form-input-togglelist 
			title="Seen by" 
			name="public" 
			v-on:validate="validate" 
			v-model="model.public" 
			:error="is.error" 
			:disabled="is.loading" 
			:validation="validation.public" 
			:options="publicOptions" 
		/>

		<core-form-input-togglelist 
			title="Used for" 
			name="context" 
			v-on:validate="validate" 
			v-model="model.context" 
			:error="is.error" 
			:disabled="is.loading" 
			:validation="validation.context" 
			:options="contextOptions" 
		/>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!model.name" v-on:click.native="onConfirmClick">Confirm</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	mixins: [FormValidation],

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			},

			model: {
				name: '',
				type: 1,
				public: 1,
				context: 0
			},

			validation: {
				name: {
					exists: true,
					max: 16
				}
			}

		}

	},

	computed: {

		typeOptions: function() {

			return [{
				value: 1,
				title: 'List',
				text: 'Table with curated fields.'
			}, {
				value: 2,
				title: 'Spreadsheet',
				text: 'Sheet format with raw fields.'
			}, {
				value: 3,
				title: 'Cards',
				text: 'Card grid with curated fields.'
			}, {
				value: 4,
				title: 'Gallery',
				text: 'Image gallery with minimal fields.'
			}]

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can use it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see and use it.'
			}]

		},

		contextOptions: function() {

			var options = [{
				value: this.$CONSTANTS.TAG.CONTEXT.GAME,
				title: 'All',
				text: 'All applicable profile screens.'
			}]

			options.push({
				value: this.$CONSTANTS.TAG.CONTEXT.COLLECTION,
				title: 'Collection',
				text: 'Only for the collection screen.'
			})

			options.push({
				value: this.$CONSTANTS.TAG.CONTEXT.RATING,
				title: 'Rating',
				text: 'Only for the ratings screen.'
			})

			options.push({
				value: this.$CONSTANTS.TAG.CONTEXT.PLAY,
				title: 'Play',
				text: 'Only for the plays screen.'
			})

			return options

		}

	},

	methods: {

        onConfirmClick: function() {

			this.is.loading = true

            this.$api.post('views/manage/create', {
				data: this.model
			}).then(function(view) {

				this.$store.commit('data/views/add', [view])

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
					id: 'viewsManage'
				})

			}.bind(this), function() {

				this.is.error = true
				this.is.loading = false

			}.bind(this)) 	

        },

		onClose: function() {

			this.$emit('close')

            this.$pubsub.$emit('open.modal', {
				id: 'viewsManage'
			})

		}

	}

}

</script>

<style scoped>

</style>